import React, { Component } from 'react';
import '../../public/css/Spotlight.css';
import SpotlightBanner from './SpotlightBanner';
import Spotlightyr from './Spotlightyr';
import $ from 'jquery'
import PreLoginPage from '../../../views/core/PreLoginPage';
import Footer from '../../../views/ke/ke_Footer';
// import PreloginLanding from '../../../views/common/PreloginLanding';

export default class ke_Spotlight extends PreLoginPage {
  constructor(props) {
    super(props);
    this.state = {
      latestKnownScrollY: 0,
      ticking: false,
      movers: 0,
      thedivcontainer: 0,
      offsetItem: 0,
      rowsViewport: 0,
      rowsOutViewport: 0,
      totalrows: 0,
      links: 0,
      inviewport: 0,
      scollPageSpeed: 2000,
      scollPageEasing: 'easeInOutExpo',
      winHeight: 0,
      winWidth: 0,
      ssparentTop: 0,
      isMobile: false
    }
  }

  componentDidMount() {
    //console.log("props ",this.props)
    setTimeout(function (me) {
      me.updateData();
    }, 100, this)

    var supportsPassive = false;

    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassive = true;
          return supportsPassive;
        }
      });
      window.addEventListener("testPassive", null, opts);
      window.removeEventListener("testPassive", null, opts);
    } catch (e) { }

    $('#spotlight-container')[0].addEventListener('scroll', this.onScroll, supportsPassive ? { passive: true } : false);

    window.addEventListener('resize', this.callwinResize);

    if (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase())) {
      $(".ss-menubtn").hide();
      this.setState({
        isMobile: true
      })
      //alert("mobile");
      $("#custom_fc_button").css("display","none");
      $(".ss-row").css("margin", "0px 8px")
      if (/iPad/i.test(navigator.userAgent) === true) {
        $(".ss-parent").css("width", "100% !important")
        $(".ss-parent").css("max-width", "100% !important")
        $("#content_sub").css("display", "flex");
        $("#content_sub").css("justify-content", "center");
        $("#content_sub").css("align-items", "center");
        $(".ss-row").css("margin", "0px 14px")
      }
      $("#content_sub").css("bottom", "0px");
     // $(".mdl-layout_container footer").css({'margin-bottom':'270px'});
    } else {
      $(".ss-menubtn").hide();
      this.setState({
        isMobile: false
      })
     // console.log("me entered in Desktop");
      $("#content_sub").css("right", "20px");
      $("#content_sub").css("width", "170px");
      $("#content_sub").css("margin-left", "10px");
      $("#content_sub").css("margin-right", "10px");
      $(".ss-links").css("display", "block");
      $("#content_sub").css("top", "200px");
     // $(".mdl-layout_container footer").css({'margin-bottom':'50px'});
    }
    //$("body").css({overflowY:"hidden"});
    this.setTitle("SPOTLIGHT_title");
    this.setMeta("SPOTLIGHT_meta");
    this.setHeading("SPOTLIGHT_heading");
  }

	componentWillUnmount(){
    $("#custom_fc_button").css("display","block");
		//console.log("componentWillUnmount")
		//$("body").css({overflowY:"auto"});
	}

 /*  showmenu = () => {
    $(".ss-menubtn").hide();
    $("#content_sub").show();
    $('#content_sub').css({ opacity: 0.0, visibility: "visible" }).animate({ opacity: 1.0 });
  } 
  closeMenu = () => {
    if (this.state.isMobile === true) {
      $(".ss-menubtn").show();
      $('.ss-menubtn').css({ opacity: 0.0, visibility: "visible" }).animate({ opacity: 1.0 });
      $("#content_sub").hide();
    }
  }*/
  
  callwinResize = () => {
    try{
      this.setState({
        winHeight: document.querySelector('#spotlight-container').getBoundingClientRect().height,
        winWidth: document.querySelector('#spotlight-container').getBoundingClientRect().width
      })
  
      this.setViewportRows();
      this.state.rowsViewport.each(function () {
        $(this).find('div.ss-left')
          .removeAttr('style')
        $(this).find('div.ss-right')
          .removeAttr('style')
      });
      this.onUpdate();
    }catch(e){

    }
  }

  updateData = () => {
    this.setState({
      movers: document.querySelectorAll('.ss-row'),
      links: document.querySelectorAll('#ss-links'),
      thedivcontainer: document.querySelector('#spotlight-container'),
      offsetItem: document.querySelector('.ss-parent'),
      winHeight: document.querySelector('#spotlight-container').getBoundingClientRect().height,
      ssparentTop: document.querySelector('.ss-parent').offsetTop
    })

    this.defineViewport();
    this.setViewportRows();
    $(this.state.movers).css({
      'perspective': 600,
      '-webkit-perspective': 600,
      'perspective-origin': '50% 0%',
      '-webkit-perspective-origin': '50% 0%'
    });

    $(this.state.rowsViewport).find('a.ss-circle').addClass('ss-circle-deco');
    this.onUpdate();
  }

  defineViewport = () => {
    $.extend($.expr[':'], {
      inviewport: function (el) {
        if (el.offsetTop + document.querySelector('.ss-parent').offsetTop < document.querySelector('#spotlight-container').getBoundingClientRect().height) {
          return true;
        }
        return false;
      }
    });
  }

  setViewportRows = () => {
    this.setState({
      rowsViewport: $(this.state.movers).filter(':inviewport'),
      rowsOutViewport: $(this.state.movers).not(this.state.rowsViewport)
    })
  }

  onScroll = () => {
    this.setState({
      latestKnownScrollY: $('#spotlight-container').scrollTop()
    })
    this.requestTick();
  };

  requestTick = () => {
    if (!this.state.ticking) {
      requestAnimationFrame(this.onUpdate);
    }
    this.setState({
      ticking: true
    })
  }

  onUpdate = () => {
    const winscroll = this.state.latestKnownScrollY - this.state.ssparentTop;
    const winCenter = this.state.winHeight / 2 + winscroll;
    const winHeight = this.state.winHeight;
    this.setState({
      ticking: false
    })

    let rowH, factor, t, o, val;

    $(this.state.rowsOutViewport).each(function (i) {
      let mover = $(this),
        rowL = mover.find('div.ss-left'),
        rowR = mover.find('div.ss-right'),
        rowT = mover[0].offsetTop;
      if (rowT <= winHeight + winscroll + 50) {
        rowH = mover.height();
        factor = (((rowT + rowH / 2) - winCenter) / (winHeight / 2 + rowH / 2));
        val = Math.max(factor * 50, 0);
        t = Math.max(factor * 75, 0);
        o = Math.min(Math.abs(factor - 1), 1);

        if (val <= 0) {
          if (!mover.data('pointer')) {
            mover.data('pointer', true);
            mover.find('.ss-circle').addClass('ss-circle-deco');
          }
        } else {
          if (mover.data('pointer')) {
            mover.data('pointer', false);
            mover.find('.ss-circle').removeClass('ss-circle-deco');
          }
        }
        $(rowL).css({
          'transform': 'translate3d(-' + t + '%, 0, 0)',
          'opacity': o
        })

        $(rowR).css({
          'transform': 'translate3d(' + t + '%, 0, 0)',
          'opacity': o
        })
      }
    })
  }

  render() {
    return (
      <div className="mdl-layout_container">
        <div className="mdl-layout mdl-js-layout mdl-layout--fixed-header topholder">
          <div id="spotlight-container" className="android-content mdl-layout__content">
         

            <section className="sections m-w">
            <SpotlightBanner title={this.rb("spotlight")}/>
              <Spotlightyr />

              <div className="ss-parent numcontent flex">
                <div id="top-ss-container" className="ss-container">
                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2019">{this.rb("2019_left1")}</h2>
                    </div>
                    <div className="ss-right">
                      <h2>{this.rb("2019_right1")}</h2>
                    </div>
                  </div>

                   <div className="ss-row ss-large">
                    <div className="ss-left notrans">
                      <a href={this.getUrlFor("2019_leftright4")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-65 ss-circle-deco">{this.rb("2019_left4")}</a>
                    </div>
                    <div className="ss-right notrans">
                      <h3>
                        <span>{this.rb("2019_right4_1")}</span>
                        <a href={this.getUrlFor("2019_leftright4")} target="_blank" rel="noopener noreferrer">{this.rb("2019_right4_2")}</a>
                      </h3>
                    </div>
                  </div>

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2019_left3_1")}</span>
                        <a href={this.getUrlFor("2019_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2019_left3_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2019_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-64 ss-circle-deco">{this.rb("2019_right3")}</a>
                    </div>
                  </div>

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2019_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-63 ss-circle-deco">{this.rb("2019_left2")}</a>
                    </div>
                    <div className="ss-right">
                      <h3>
                        <span>{this.rb("2019_right2_1")}</span>
                        <a href={this.getUrlFor("2019_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2019_right2_2")}</a>
                      </h3>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2019_left1_1")}</span>
                        <a href={this.getUrlFor("2019_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2019_left1_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2019_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-62 ss-circle-deco">{this.rb("2019_right0")}</a>
                    </div>
                  </div>

                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2018">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right">
                      <h2>{this.rb("2018_right1")}</h2>
                    </div>
                  </div>

                  {/* 2018 new */}

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2018_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-61 ss-circle-deco">{this.rb("2018_right4")}</a>
                    </div>
                    <div className="ss-right">
                      <h3>
                        <span>{this.rb("2018_left4_1")}</span>
                        <a href={this.getUrlFor("2018_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2018_left4_2")}</a>
                      </h3>
                    </div>
                  </div>
                  
                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2018_right3_1")}</span>
                        <a href={this.getUrlFor("2018_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2018_right3_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2018_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-60 ss-circle-deco">{this.rb("2018_left3")}</a>
                    </div>
                  </div>

                  {/* 2018 old */}

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2018_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-59 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right">
                      <h3>
                        <span>{this.rb("2018_right2_1")}</span>
                        <a href={this.getUrlFor("2018_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2018_right2_2")}</a>
                      </h3>
                    </div>
                  </div>

                  {/* 2018  */}

                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2017">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right">
                      <h2>{this.rb("2017_right1")}</h2>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2017_left2_1")}</span>
                        <a href={this.getUrlFor("2017_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2017_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2017_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-58 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-medium" >
                    <div className="ss-left" >
                      <a href={this.getUrlFor("2017_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-51 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2017_right3_1")}</span>
                        <a href={this.getUrlFor("2017_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2017_right3_2")}</a>
                      </h3>
                    </div>
                  </div>


                  {/* <div className="ss-row ss-medium">
                    <div className="ss-left" >
                      <h3>
                        <span>{this.rb("2017_left4_1")}</span>
                        <a href={this.getUrlFor("2017_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2017_left4_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2017_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-57 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                  </div> */}


                  <div className="ss-row ss-large">
                    <div className="ss-left" >
                      <a href={this.getUrlFor("2017_leftright4")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-46 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2017_right5_1")}</span>
                        <a href={this.getUrlFor("2017_leftright4")} target="_blank" rel="noopener noreferrer">{this.rb("2017_right5_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left" >
                      <h2 id="a2016">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>2016</h2>
                    </div>
                  </div>

                  
                  <div className="ss-row ss-medium">
                    <div className="ss-left" >
                      <h3>
                        <span>{this.rb("2016_left2_1")}</span>
                        <a href={this.getUrlFor("2016_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2016_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2016_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-45 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                  </div>
                  <div className="ss-row ss-medium">
                    <div className="ss-left" >
                      <a href={this.getUrlFor("2016_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-44 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2016_right3_1")}</span>
                        <a href={this.getUrlFor("2016_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2016_right3_1")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-small">
                    <div className="ss-left" >
                      <h3>
                        <span>{this.rb("2016_left4_1")}</span>
                        <a href={this.getUrlFor("2016_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2016_left4_1")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2016_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-43 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                  </div>


                  {/* <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2016_left5_1")}</span>
                        <a href={this.getUrlFor("2016_leftright4")} target="_blank" rel="noopener noreferrer">{this.rb("2016_left5_1")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2016_leftright4")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-42a ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                  </div> */}

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2016_leftright5")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-42 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2016_right6_1")}</span>
                        <a href={this.getUrlFor("2016_leftright5")} target="_blank" rel="noopener noreferrer">{this.rb("2016_right6_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2016_left7_1")}</span>
                        <a href={this.getUrlFor("2016_leftright6")} target="_blank" rel="noopener noreferrer">{this.rb("2016_left7_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2016_leftright6")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-41 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                  </div>




                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2016_leftright7")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-40 ss-circle-deco">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2016_right8_1")}</span>
                        <a href={this.getUrlFor("2016_leftright7")} target="_blank" rel="noopener noreferrer">{this.rb("2016_right8_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2015">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2015_right1")}</h2>
                    </div>
                  </div>



                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2015_left2_1")}</span>
                        <a href={this.getUrlFor("2015_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2015_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2015_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-39">{this.rb("2018_left2")}</a>
                    </div>
                  </div>

                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2014">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2014_right1")}</h2>
                    </div>
                  </div>

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2014_left2_1")}</span>
                        <a href={this.getUrlFor("2014_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2014_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2014_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-38">{this.rb("2018_left2")}</a>
                    </div>
                  </div>
                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2014/The_gift_of_learning-AsiaOne_Edvantage_News_March_2014.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-37">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2014_right3_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2014/The_gift_of_learning-AsiaOne_Edvantage_News_March_2014.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2014_right3_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2013">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2013_right1")}</h2>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2013_left2_1")}</span>
                        <a href={this.getUrlFor("2013_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2013_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2013_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-47">{this.rb("2013_right2")}</a>
                    </div>
                  </div>



                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2013_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-36">{this.rb("2018_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2013_right3_1")}</span>
                        <a href={this.getUrlFor("2013_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2018_left2")}</a>
                      </h3>
                    </div>
                  </div>

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2013_left3_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2013/sa_apr2013.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2013_left3_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2013/sa_apr2013.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-34">{this.rb("2013_right3")}</a>
                    </div>
                  </div>



                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2012">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2012_right1")}</h2>
                    </div>
                  </div>
                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2012_left2_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/math_makers.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2012_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/math_makers.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-35">{this.rb("2012_right2")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2012_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-33">{this.rb("2012_left3")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2012_right3_1")}</span>
                        <a href={this.getUrlFor("2012_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2012_right3_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2012_left4_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/dc_feb2012.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2012_left4_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/dc_feb2012.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-32">{this.rb("2012_right4")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/et_feb2012.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-31">{this.rb("2012_left5")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2012_right5_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/et_feb2012.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2012_right5_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2012_left6_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/th_jan2012.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2012_left6_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/th_jan2012.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-30">{this.rb("2012_right6")}</a>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2011">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2011_right1")}</h2>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2011/digitlearning_aug2011.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-29">{this.rb("2011_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2011_right2_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2011/digitlearning_aug2011.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2011_right2_2")}</a>
                      </h3>
                    </div>
                  </div>


                  {/* <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2011_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-28">{this.rb("2011_left3")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2011_right3_1")}</span>
                        <a href={this.getUrlFor("2011_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2011_right3_2")}</a>
                      </h3>
                    </div>
                  </div> */}



                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2010">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2010_right1")}</h2>
                    </div>
                  </div>
                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2010_left2_1")}</span>
                        <a href={this.getUrlFor("2010_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2010_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2010_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-26">{this.rb("2010_right2")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2010_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-25">{this.rb("2010_left3")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2010_right3_1")}</span>
                        <a href={this.getUrlFor("2010_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2010_right3_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2010_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-24">{this.rb("2010_left4")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2010_right4_1")}</span>
                        <a href={this.getUrlFor("2010_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2010_right4_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2010_left5_1")}</span>
                        <a href={this.getUrlFor("2010_leftright4")} target="_blank" rel="noopener noreferrer">{this.rb("2010_left5_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2010_leftright4")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-23">{this.rb("2010_right5")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2010_leftright5")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-22">{this.rb("2010_left6")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2010_right6_1")}</span>
                        <a href={this.getUrlFor("2010_leftright5")} target="_blank" rel="noopener noreferrer">{this.rb("2010_right6_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2010_left7_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/SmartCEO.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2010_left7_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/SmartCEO.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-21">{this.rb("2010_right7")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/inc_indiaEmagazine.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-20">{this.rb("2010_left8")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2010_right8_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/inc_indiaEmagazine.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2010_right8_2")}</a>
                      </h3>
                    </div>
                  </div>
                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2010_left9_1")}</span>
                        <a href={this.getUrlFor("2010_leftright8")} target="_blank" rel="noopener noreferrer">{this.rb("2010_left9_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2010_leftright8")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-49">{this.rb("2010_right9")}</a>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2009">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2009_right1")}</h2>
                    </div>
                  </div>


                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2009_left2_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/Confluence_09.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2009_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/Confluence_09.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-19">{this.rb("2009_right2")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/IIMB_RoundTable%5B1%5D.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-18">{this.rb("2009_left3")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2009_right3_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/IIMB_RoundTable%5B1%5D.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2009_right3_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2009_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-17">{this.rb("2009_left4")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2009_left4_1")}</span>
                        <a href={this.getUrlFor("2009_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2009_left4_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2008">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2008_right1")}</h2>
                    </div>
                  </div>
                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2008_left2_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economic_Times_June%206_2008.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2008_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economic_Times_June%206_2008.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-16">{this.rb("2008_right2")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economist-mar08.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-15">{this.rb("2008_left3")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2008_right3_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economist-mar08.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2008_right3_2")}</a>
                      </h3>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2008_left4_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/timesofindia_may08.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2008_left4_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/timesofindia_may08.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-14">{this.rb("2008_right4")}</a>
                    </div>
                  </div>

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Westport-Nov08.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-13">{this.rb("2008_left5")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2008_right5_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Westport-Nov08.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2008_right5_2")}</a>
                      </h3>
                    </div>
                  </div>

                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2008_left6_1")}</span>
                        <a href={this.getUrlFor("2008_leftright5")} target="_blank" rel="noopener noreferrer">{this.rb("2008_left6_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2008_leftright5")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-12">{this.rb("2008_right6")}</a>
                    </div>
                  </div>


                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2007">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2007_right1")}</h2>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2007_leftright1")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-9">{this.rb("2007_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2007_right2_1")}</span>
                        <a href={this.getUrlFor("2007_leftright1")} target="_blank" rel="noopener noreferrer">{this.rb("2007_right2_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2007_left3_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/outlook.jpg"} target="_blank" rel="noopener noreferrer">{this.rb("2007_left3_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/outlook.jpg"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-10">{this.rb("2007_right3")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2007_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-53">{this.rb("2007_left4")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2007_right4_1")}</span>
                        <a href={this.getUrlFor("2007_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2007_right4_2")}</a>
                      </h3>
                    </div>
                  </div>



                  {/* <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2007_left5_1")}</span>
                        <a href={this.getUrlFor("2007_leftright4")} target="_blank" rel="noopener noreferrer">{this.rb("2007_left5_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2007_leftright4")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-55">{this.rb("2007_right5")}</a>
                    </div>
                  </div> */}


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/Indiatoday_march122007%28article%29.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-11">{this.rb("2007_left6")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2007_right6_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/Indiatoday_march122007%28article%29.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2007_right6_2")}</a>
                      </h3>
                    </div>
                  </div>

                  
                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2006">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2006_right1")}</h2>
                    </div>
                  </div>
                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Raffle-Indian_Maths _Tamil_Murasu.jpg"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-56">{this.rb("2006_left2")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2006_right2_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Raffle-Indian_Maths _Tamil_Murasu.jpg"} target="_blank" rel="noopener noreferrer">{this.rb("2006_right2_2")}</a>
                      </h3>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2006_left3_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/RI_exampapersonline-Nov06.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2006_left3_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/RI_exampapersonline-Nov06.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-5">{this.rb("2006_right3")}</a>
                    </div>
                  </div>


                  
                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/November_17_2006.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-6">{this.rb("2006_left4")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2006_right4_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/November_17_2006.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2006_right4_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2006_leftright4")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-4">{this.rb("2006_left5")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2006_right5_1")}</span>
                        <a href={this.getUrlFor("2006_leftright4")} target="_blank" rel="noopener noreferrer">{this.rb("2006_right5_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2006_left6_1")}</span>
                        <a href={this.getUrlFor("2006_leftright5")} target="_blank" rel="noopener noreferrer">{this.rb("2006_left6_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2006_leftright5")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-48">{this.rb("2006_right6")}</a>
                    </div>
                  </div>

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Simplifying_problems in_learning_maths.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-50">{this.rb("2006_left7")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2006_right7_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Simplifying_problems in_learning_maths.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2006_right7_2")}</a>
                      </h3>
                    </div>
                  </div>


                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2006_left8_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/BBC-july%2006.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2006_left8_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/BBC-july%2006.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-8">{this.rb("2006_right8")}</a>
                    </div>
                  </div>


                  <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/New_York_Times-mar06.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-7">{this.rb("2006_left9")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2006_right9_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/New_York_Times-mar06.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2006_right9_2")}</a>
                      </h3>
                    </div>
                  </div>
                  <div className="ss-row">
                    <div className="ss-left">
                      <h2 id="a2005">{this.rb("2018_left1")}</h2>
                    </div>
                    <div className="ss-right" >
                      <h2>{this.rb("2005_right1")}</h2>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2005_left2_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/SIMEX_Chennai.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2005_left2_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/SIMEX_Chennai.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-3">{this.rb("2005_right2")}</a>
                    </div>
                  </div>


                  {/* <div className="ss-row ss-small">
                    <div className="ss-left">
                      <a href={this.getUrlFor("2005_leftright2")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-2">{this.rb("2005_left3")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2005_right3_1")}</span>
                        <a href={this.getUrlFor("2005_leftright2")} target="_blank" rel="noopener noreferrer">{this.rb("2005_right3_2")}</a>
                      </h3>
                    </div>
                  </div> */}

                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2005_left4_1")}</span>
                        <a href={this.getUrlFor("2005_leftright3")} target="_blank" rel="noopener noreferrer">{this.rb("2005_left4_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("2005_leftright3")} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-1">{this.rb("2005_right4")}</a>
                    </div>
                  </div>

                  <div className="ss-row ss-large">
                    <div className="ss-left">
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Hey_its_math_the_singapore_way.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-54">{this.rb("2005_left5")}</a>
                    </div>
                    <div className="ss-right" >
                      <h3>
                        <span>{this.rb("2005_right5_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Hey_its_math_the_singapore_way.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2005_right5_1")}</a>
                      </h3>
                    </div>
                  </div>
                  <div className="ss-row ss-medium">
                    <div className="ss-left">
                      <h3>
                        <span>{this.rb("2005_left6_1")}</span>
                        <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Singapores_racing_US_to_the_top.pdf"} target="_blank" rel="noopener noreferrer">{this.rb("2005_left6_2")}</a>
                      </h3>
                    </div>
                    <div className="ss-right" >
                      <a href={this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Singapores_racing_US_to_the_top.pdf"} target="_blank" rel="noopener noreferrer" className="ss-circle ss-circle-52">{this.rb("2005_right6")}</a>
                    </div>
                  </div>


                </div>
              </div>
                 <Footer showContactus={this.props.showContactus} products_category_order={this.props.products_category_order} products_category={this.props.products_category} classes={this.props.classes}  grades={this.props.grades} products_class={this.props.products_class}>
            </Footer>
            </section>
        
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/prelogin/src/components/ke_Spotlight.js